import { render } from "./StatusText.vue?vue&type=template&id=6e8a2424&scoped=true"
import script from "./StatusText.vue?vue&type=script&lang=js"
export * from "./StatusText.vue?vue&type=script&lang=js"

import "./StatusText.vue?vue&type=style&index=0&id=6e8a2424&lang=scss&scoped=true"

import exportComponent from "/Users/sherinbloemendaal/projects/spb/pricetiger/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e8a2424"]])

export default __exports__